import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const VolumeMute = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="VolumeMute" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.3594 2.23155C11.6574 1.98319 12.0725 1.93034 12.4238 2.09484C12.7752 2.25942 13 2.61211 13 3.00011V21.0001C13 21.3894 12.774 21.7435 12.4209 21.9073C12.0675 22.0711 11.6507 22.0146 11.3535 21.7628L5.73242 17.0001H3C1.34318 17.0001 5.73459e-05 15.6569 0 14.0001V10.0001C0 8.34326 1.34315 7.00011 3 7.00011H5.63672L11.3594 2.23155ZM6.64062 8.76866C6.46092 8.9184 6.23391 9.00011 6 9.00011H3C2.44772 9.00011 2 9.44782 2 10.0001V14.0001C2.00006 14.5523 2.44775 15.0001 3 15.0001H6.09863L6.1875 15.004C6.39233 15.0222 6.58712 15.1036 6.74512 15.2374L11 18.8419V5.13585L6.64062 8.76866Z" fill="#000" /><path d="M21.707 9.70714L19.4141 12.0001L21.707 14.2931L20.293 15.7071L18 13.4142L15.707 15.7071L14.293 14.2931L16.5859 12.0001L14.293 9.70714L15.707 8.29308L18 10.586L20.293 8.29308L21.707 9.70714Z" fill="#000" />
  </StyledIcon>
));

VolumeMute.displayName = 'VolumeMute';

export { VolumeMute };
